import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { Slice, Country } from './types'
import { PWAThunk } from 'lib/core/data'

export const initialState: Slice = {
  payload: [],
  isFetching: false,
  isSuccess: false,
  isFailure: false
}

const slice = createSlice({
  name: 'common/countryList',
  initialState,
  reducers: {
    request (state) {
      state.isFetching = true
    },

    success (state, action: PayloadAction<Country[]>) {
      state.isFetching = false
      state.isSuccess = true
      state.isFailure = false
      state.payload = action.payload
    },

    failure (state) {
      state.isFetching = false
      state.isSuccess = false
      state.isFailure = true
      state.payload = initialState.payload
    }
  }
})

export const reducer = slice.reducer

export const { request, success, failure } = slice.actions

export const fetchCountries = (): PWAThunk => {
  return async (dispatch, getState, params) => {
    const { magentoClient } = params
    dispatch(request())
    try {
      const response = await magentoClient.getClient().directory.fetchCountries()
      const { data } = response || {}
      const { countries } = data || {}
      if (countries) {
        dispatch(success(countries))
      } else {
        dispatch(failure())
      }
      return response
    } catch (e) {
      dispatch(failure())
    }
  }
}
